
import React, { useEffect, useState } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import editIcon from "../../../resources/images/pencile.svg"
import flagIcon from "../../../resources/images/flagIcon.svg"
import deleteIcon from "../../../resources/images/delete.svg"
import cloneIcon from "../../../resources/images/clone.svg"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { ApplicantActions } from '../../../actions';

function VarticalDropdownMenuComponent(props) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const [flagged, setflagged] = useState(props?.row?.flagged)
    const user = useSelector((state) => state.authentication.user);

    useEffect(() => {
        setflagged(props?.row?.flagged)
    }, [props?.row?.flagged])
    
    const deleteClick = () => {
        if (props?.row?.id) {
            props.setDeleteId(props?.row?.id);
        }
    };
    const addFlag = () => {
        if (props?.row?.id) {
            setflagged((prevData)=>!prevData)
            props.setActiveData({...props?.row , flagged:flagged});
        }
    }   
    const dispatch = useDispatch()
    const editData = useSelector((state) => state.applicant.boardApplicant)
    const editClick = () => {
        dispatch(ApplicantActions.getApplicant(props?.row?.id)).then(res => {
            if (res) {
                props.setEditedData(res)
            }
        })


    }
    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className={props?.className}>
            <DropdownToggle caret >
                <BsThreeDots />
            </DropdownToggle>
            <DropdownMenu>
                {user && user?.userRole !== 4 ?
                    <DropdownItem onClick={() => editClick()}><img src={editIcon} className="drop-icon" /> Edit</DropdownItem> : ""
                }
                <DropdownItem onClick={() => addFlag()}>
                    {" "}
                    <img src={flagIcon} className="drop-icon" /> {flagged? 'Remove Flag' : 'Add Flag'}
                </DropdownItem>
                {user && user?.userRole !== 4 ?
                    <DropdownItem onClick={() => deleteClick()}>
                        {" "}
                        <img src={deleteIcon} className="drop-icon" /> Delete
                    </DropdownItem> : ""
                }
                {user && user?.userRole !== 4 ?
                    <DropdownItem onClick={() => {
                        props.referredProfileToggle()
                        }}>
                        {" "}
                        <img src={cloneIcon} className="drop-icon" />Clone to another job profile
                    </DropdownItem> : ""
                }
            </DropdownMenu>
        </Dropdown>
    );
}
export default VarticalDropdownMenuComponent;